/**
 * @desc 编辑sku/物料是否可采购
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  params: API.basics.plmProductSku.editSkuPurchaseFlag.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/editSkuPurchaseFlag`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
